module.exports = __webpack_public_path__ + "static/img/sidebar-logo.9f82e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/sidebar-logo.png
// module id = i1oZ
// module chunks = 1